import React, {ComponentType} from "react";
import TimeSelector from "external-components/time-selector";
import {IProps, IContainerProps, IServices, IHandlers, classPrefix} from 'external-components/time-selector/types'

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";

const NS = 'TimeSelectorContainer';


const propsKeys: string[] = keys<IProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function(all: IProps & IContainerProps & IHandlers & IServices) {

  /**
    * Sorts 'all' into IServices, IProps and IContainerProps
    */
  const {}: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices;
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const {
    preselectedTimeIndex,
    preselectedTime,
    times,
    isCustomTime,
    useReversedColors,
    onSelectedChanged,
    isLockedBooking
  }: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

  props.preselectedTimeIndex = preselectedTimeIndex || 0;
  props.preselectedTime = preselectedTime || null;
  props.times = times || null;
  props.isCustomTime = isCustomTime;
  props.useReversedColors = useReversedColors;
  props.isLockedBooking = isLockedBooking;

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    handleSelectedChanged: onSelectedChanged
  }

  return ReactUtilsService.containerWrap(
    <TimeSelector {...props} {...handlers} />, classPrefix
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ATimeSelector: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
